/* eslint-disable consistent-return */
import { Icon } from '@zoom/components';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from 'reactstrap';

import { suppressContextMenuHandler } from '../../../components/Dropdown/UncontrolledDropdown';
import { Queue, Skill } from '../../../graphql/components';
import { Agent } from '../../Agents/types';
import { getAgentDetailButtonTag, getAgentsDetailTag } from '../constants';

interface AgentDetailProps {
  agent: Agent;
  queues: Record<string, Queue>;
  skills: Record<string, Skill>;
}

export const AgentDetail: React.FC<AgentDetailProps> = ({ agent, queues, skills }) => {
  const { t } = useTranslation();

  const [menuOpened, setMenuOpened] = useState(false);
  const [isContainerAttached, setContainerAttached] = useState(false);

  const iconRef = useRef<HTMLDivElement>(null);
  const contextMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setContainerAttached(true);
  }, []);

  return (
    <>
      <div
        ref={iconRef}
        className="persons-bulk-assign__agent-detail-popover-container"
        onMouseEnter={() => setMenuOpened(true)}
        onMouseLeave={() => setMenuOpened(false)}
      >
        <Icon kind="ico_question-mark" size={14} data-test-id={getAgentDetailButtonTag(agent.id)} color="blue-light" />
      </div>
      {isContainerAttached && (
        <Popover
          isOpen={menuOpened}
          target={iconRef.current!}
          placement="top"
          fade={false}
          className="persons-bulk-assign__agent-detail-popover"
        >
          <div ref={contextMenuRef} onContextMenu={suppressContextMenuHandler}>
            <div className="popover-menu__body">
              <div className="popover-menu__queues-wrapper">
                <div className="popover-menu__queues-heading">
                  <div className="popover-menu__queues-title">{t('queue.queues')}</div>
                  <div className="popover-menu__skills-title">{t('skill.skills')}</div>
                </div>
                {/* eslint-disable-next-line array-callback-return */}
                {agent.queueIds?.map((queueId) => {
                  const queue = queues[queueId];

                  // Render only queue info related to queues selected to Schedule
                  if (queue) {
                    const skill = queue.skillId ? skills[queue.skillId] : undefined;
                    return (
                      <div className="popover-menu__queue-wrapper" key={queueId}>
                        <div
                          data-test-id={getAgentsDetailTag(agent.id, 'queue-name')}
                          className="popover-menu__queue-name"
                        >
                          {queue.name}
                        </div>
                        {skill && (
                          <div
                            data-test-id={getAgentsDetailTag(agent.id, 'queue-skill')}
                            className="popover-menu__queue-skill"
                          >
                            {skill.name}
                          </div>
                        )}
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </Popover>
      )}
    </>
  );
};
